// extracted by mini-css-extract-plugin
export default {"task_container":"Tasks_task_container__I1Dd6","fakemasonry":"Tasks_fakemasonry__CqnSP","item":"Tasks_item__-chVf"};